import Button, { buttonClassNames } from '@components/primitives/Button'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { useRouter } from 'next/navigation'
import { useToggleFilterModal } from '../Hooks/useToggleFilterModal'

export default function MobileFilterOverlayFooter({
  nbHits,
}: {
  nbHits: number
}) {
  const router = useRouter()
  const toggleFilter = useToggleFilterModal()

  const handleClearAll = () => {
    const newSearchParams = new URLSearchParams()
    router.push(`?${newSearchParams.toString()}`)
  }

  return (
    <div className='grid grid-cols-2 items-center gap-2 p-4'>
      <Button
        className={classMerge(buttonClassNames.text.black, 'py-4')}
        onClick={handleClearAll}
      >
        Clear all
      </Button>
      <Button
        className={classMerge(buttonClassNames.legacy.fill.black, 'w-full')}
        onClick={toggleFilter}
      >
        <Text
          className='text-white antialiased'
          element='p'
          styleName='p-small-strong'
        >
          {nbHits === 0 ? 'No Results' : `View ${nbHits}+ Trials`}
        </Text>
      </Button>
    </div>
  )
}
